import { Doughnut } from 'react-chartjs-2';

const centerTextPlugin = {
  id: 'centerText',
  beforeDraw: (chart) => {
    const { width, height, ctx } = chart;
    const text = chart.options.plugins.centerText?.text;
    if (!text) return;

    ctx.save();
    ctx.font = 'bold 24px sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, width / 2, height / 2);
    ctx.restore();
  },
};

const DoughnutChart = ({ chartData, centerValue }) => {
  if (!chartData || chartData.length === 0) {
    return <div>No data provided for the doughnut chart.</div>;
  }

  const labels = chartData.map(item => item.LABEL);

  const datasets = Object.keys(chartData[0])
    .filter(key => key !== 'LABEL')
    .map((key, index) => ({
      label: key,
      data: chartData.map(item => item[key]),
      backgroundColor: ['#1e4263', '#9E9E9E', '#FFCE56', '#4BC0C0', '#9966FF'],
    }));

  const data = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.formattedValue}`,
        },
      },
      centerText: {
        display: true,
        text: centerValue.value,
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
    </div>
  );
};

export default DoughnutChart;
